import { render, staticRenderFns } from "./StaffEdit.vue?vue&type=template&id=dcd83f4c"
import script from "./StaffEdit.vue?vue&type=script&lang=js"
export * from "./StaffEdit.vue?vue&type=script&lang=js"
import style0 from "./StaffEdit.vue?vue&type=style&index=0&id=dcd83f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports